import styled, { CSSObject } from '@emotion/styled';
import { FC } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface DraggableContainerProps {
  isDragging: boolean;
  selected?: boolean;
}

const DraggableContainer = styled.div<DraggableContainerProps>(
  ({ theme, isDragging, selected }): CSSObject => ({
    userSelect: 'none',
    padding: '1rem',
    marginBottom: '1rem',
    backgroundColor: selected
      ? isDragging
        ? theme.palette.primary.dark
        : theme.palette.primary.main
      : isDragging
      ? theme.palette.secondary.dark
      : theme.palette.secondary.main,
    color: selected ? theme.palette.primary.contrastText : theme.palette.secondary.contrastText,
    fontFamily: theme.typography.fontFamily,
    cursor: 'pointer',
  })
);

interface Props {
  id: string;
  title: string;
  selected?: boolean;
  isDragDisabled?: boolean;
  onClick: (id: string) => void;
}

export const SlideListItem: FC<Props> = ({ id, title, selected, isDragDisabled, onClick }) => {
  const handleItemClick = (id: string) => () => onClick(id);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled: isDragDisabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <DraggableContainer
      key={id}
      isDragging={isDragging}
      selected={selected}
      onClick={handleItemClick(id)}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      {title}
    </DraggableContainer>
  );
};
